import {
   EMPTY_STRING,
   HTTPS_PREFIX,
   isDevelopmentEnvironment,
   isProductionEnvironment,
   SLASH_REGEX
} from '@flowwai-frontend/shared/constants'

export const disableConsoleObjects = (): void => {
   if (!isDevelopmentEnvironment) {
      //NOTE: The below line will suppress all `console.log`s in Production Environment.
      console.log = () => null
   }

   if (isProductionEnvironment) {
      //NOTE: The below line will suppress below mentioned `console`s in Staging & Production Environment.
      console.assert = () => null
      console.count = () => null
      console.debug = () => null
      console.dir = () => null
      console.error = () => null
      console.group = () => null
      console.groupCollapsed = () => null
      console.groupEnd = () => null
      console.info = () => null
      console.profile = () => null
      console.profileEnd = () => null
      console.trace = () => null
      console.table = () => null
      console.time = () => null
      console.timeLog = () => null
      console.warn = () => null
   }
}

export const getAppHostNameFromURL = (appUrl: string): string => {
   const baseURL = appUrl.replace(HTTPS_PREFIX, EMPTY_STRING)

   const hasSlash = baseURL.includes('/')

   if (hasSlash) {
      const appHostName = baseURL.replace(SLASH_REGEX, EMPTY_STRING)

      return appHostName
   }

   return baseURL
}
